import React, { useEffect, useState } from 'react';


const ObjectTool = ({ canvas, className='right', onToggleHelp=f=>f })=>{
    const [active, setActive] = useState(false);

    useEffect(() => {
        if( null===canvas ) return;
        canvas.on('selection:created', onSelectionCreated);
        canvas.on('selection:cleared', onSelectionCleared);
        return ()=>{
            canvas.off('selection:created', onSelectionCreated);
            canvas.off('selection:cleared', onSelectionCleared);
        }
    }, [canvas]);

    function onSelectionCreated(event){
        setActive(true);
    }

    function onSelectionCleared(event){
        setActive(false);
    }

    function onSendToBack(){
        let object = canvas.getActiveObject();
        if(null===object )return;
        canvas.sendToBack(object);
    }

    function onSendBackword(){
        let object = canvas.getActiveObject();
        if(null===object )return;
        canvas.sendBackwards(object);
    }

    function onBringFoward(){
        let object = canvas.getActiveObject();
        if(null===object )return;
        canvas.bringForward(object);
    }

    function onBringToFront(){
        let object = canvas.getActiveObject();
        if(null===object )return;
        canvas.bringToFront(object);
    }

    function onHorizontalFlip(){
        let object = canvas.getActiveObject();
        if(null===object )return;
        object.set('flipX', !object.get('flipX'));
        canvas.renderAll();
    }
    function onVerticalFlip(){
        let object = canvas.getActiveObject();
        if(null===object )return;
        object.set('flipY', !object.get('flipY'));
        canvas.renderAll();
    }

    function removeObject(){
        let object = canvas.getActiveObject();
        if(null===object)return;
        if(object._objects===undefined){
            canvas.remove(object);
        }else{
            object._objects.forEach(element => {
                canvas.setActiveObject(element);
                canvas.remove(element);
            });
        }
    }//end removeObject

    
    if( canvas===null )return null;
    return(
        <div className={`object_menu ${className}`}> 
            <button className="btn _xsm btn_object object_btf" onClick={onBringToFront} disabled={!active}><span>맨앞</span></button>
            <button className="btn _xsm btn_object object_bf" onClick={onBringFoward} disabled={!active}><span>앞</span></button>
            <button className="btn _xsm btn_object object_bb" onClick={onSendBackword} disabled={!active}><span>뒤</span></button>
            <button className="btn _xsm btn_object object_btb" onClick={onSendToBack} disabled={!active}><span>맨뒤</span></button>
            <button className="btn _xsm btn_object object_flip_y" onClick={onHorizontalFlip} disabled={!active}><span>좌우</span></button>
            <button className="btn _xsm btn_object object_flip_x" onClick={onVerticalFlip} disabled={!active}><span>상하</span></button>
            <button className="btn _xsm object_delete" onClick={removeObject}  disabled={!active}>삭제</button>
            <button className="btn _xsm guide_btn" onClick={onToggleHelp}>이용방법?</button>
        </div>
    );
}

export default ObjectTool;